module.exports = __webpack_public_path__ + "static/media/slapping.83983231.mp4";